import { sendEventToJumbo } from './jumbo';

export const SEARCH_EVENTS = {
  SEARCH_ORDER_DETAILS_SUCCESS: 'search_order_details_success',
  SEARCH_ORDER_DETAILS_FAILURE: 'search_order_details_failure',
  BLOCKING_MODAL_VISIBLE: 'blocking_popup_visible',
  BLOCKING_MODAL_CLOSE: 'blocking_popup_close',
  LOAD_MORE_ORDERS_EVENT: 'load_more_orders_event',
  BANNER_TRAIL_VISIBLE_EVENT: 'banner_trail_visible_event',
  BANNER_CLICK_EVENT: 'banner_click_event',
};

export const sendSearchApiEvents = (eventName, requestMeta = {}) => {
  sendEventToJumbo({
    eventName,
    requestMeta,
  });
};

export const sendBlockingPopupEvents = (eventName, requestMeta = {}) => {
  sendEventToJumbo({
    eventName,
    requestMeta,
  });
};

export const sendLoadMoreOrderEvents = () => {
  sendEventToJumbo({
    eventName: SEARCH_EVENTS.LOAD_MORE_ORDERS_EVENT,
  });
};

export const sendBannerEvents = (eventName, requestMeta = {}) => {
  sendEventToJumbo({
    eventName,
    requestMeta,
  });
};
